import { motion, AnimatePresence } from "framer-motion";
import { MdClose } from "react-icons/md";
import { useState, useCallback } from "react";

export default function CustomToast() {
    const [toast, setToast] = useState(null);

    // ✅ Show toast function
    const showToast = useCallback((message, type = "success") => {
        setToast({ message, type });
        setTimeout(() => setToast(null), 3000); // auto close in 3s
    }, []);

    const handleClose = () => setToast(null);

    // ✅ Expose showToast globally (optional)
    window.showToast = showToast;

    const typeStyles = {
        success: "bg-green-100 text-green-700 border-green-300",
        error: "bg-red-100 text-red-700 border-red-300",
        info: "bg-blue-100 text-blue-700 border-blue-300"
    };

    return (
        <AnimatePresence>
            {toast && (
                <motion.div
                    initial={{ x: 300, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ x: 300, opacity: 0 }}
                    transition={{ type: "spring", stiffness: 300, damping: 30 }}
                    className={`fixed inset-x-4 md:inset-auto md:right-5 top-[calc(env(safe-area-inset-top)+4rem)] md:top-5 z-[9999] max-w-sm w-auto shadow-lg rounded-lg p-4 flex items-center justify-between border ${typeStyles[toast.type]}`}
                >
                    <p className="text-sm font-medium">{toast.message}</p>
                    <button
                        onClick={handleClose}
                        className="ml-3 text-gray-500 hover:text-gray-700 focus:outline-none"
                    >
                        <MdClose size={18} />
                    </button>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
